import { LegalShell } from "../components/LegalShell";
import { useSeo } from "../lib/useSeo";

const Disclaimer = () => {
    useSeo({
        title: "Disclaimer | Shillong Morning Teer Result Today",
        description: "Official disclaimer for Shillong Morning Teer Result Today. Results and predictions are for informational purposes only and are not a substitute for official announcements.",
        keywords: "shillong morning teer disclaimer, morning teer legal disclaimer",
        path: "/disclaimer",
        breadcrumbs: [
            { name: "Home", path: "/" },
            { name: "Disclaimer", path: "/disclaimer" },
        ],
    });

    return (
        <LegalShell title="Disclaimer" breadcrumb="Disclaimer" subtitle="Please read this disclaimer carefully.">
            <p>
                The information published on <strong>Shillong Morning Teer Result Today</strong> is
                provided in good faith and for <strong>general informational purposes only</strong>.
                We make no representation or warranty, express or implied, regarding the accuracy,
                completeness, reliability or availability of any information on the website.
            </p>

            <h2>No Endorsement of Gambling</h2>
            <p>
                Teer is a traditional archery-based number game practised legally in Meghalaya, India.
                This website is <strong>not a gambling platform</strong>. We do not accept, process or
                facilitate any bets. We do not encourage participation from readers in jurisdictions
                where the game is not permitted.
            </p>

            <h2>Not Financial Advice</h2>
            <p>
                Common numbers, dream numbers and direct hit guti are compiled from public analysis
                and reader submissions. They must not be treated as guarantees, predictions, or
                financial advice. Any decision you take based on these numbers is entirely at your
                own risk.
            </p>

            <h2>Data Accuracy</h2>
            <p>
                Results are updated as soon as they are announced at the respective archery club.
                Occasional delays or corrections may occur. Always confirm the final numbers with the
                officially recognised source before acting on them.
            </p>

            <h2>External Links</h2>
            <p>
                Our website may contain links to third-party websites and applications (WhatsApp,
                Telegram, social platforms, etc.). We have no control over the content of these sites
                and accept no responsibility for their accuracy, legality or safety.
            </p>

            <h2>Age Restriction</h2>
            <p>
                Visitors must be at least 18 years of age (or the legal age of majority in their
                jurisdiction) to view Teer-related content. If you are underage, please leave this
                website.
            </p>

            <h2>Consent</h2>
            <p>
                By using this website, you consent to this Disclaimer and to our Terms &amp;
                Conditions and Privacy Policy.
            </p>
        </LegalShell>
    );
};

export default Disclaimer;
